import { useParams } from 'react-router-dom';
import { AgentRun } from '../components/agent';
import { LeftNav } from '../components/nav';

export default function Run() {
  const { agentId } = useParams();

  return <LeftNav>{agentId && <AgentRun agentId={agentId} />}</LeftNav>;
}
